import React, { useMemo } from 'react';

import { useMidnightRollover } from '../../hooks/useMidnightRollover';
import LocalTime, { CalendarDate } from './LocalTime';

// never display timestamps older than this
const TIMESTAMP_CUTOFF = 1000180800;

const DayDivider = ({ timestamp, enabled }) => {
  const midnightTick = useMidnightRollover();

  const calendarDate = useMemo(() => {
    if (!timestamp) return null;
    return CalendarDate.fromDate(new Date(timestamp * 1000));
  }, [timestamp]);

  const daysPassed = calendarDate ? calendarDate.daysPassed() : null;

  if (!enabled) return null;
  if (!timestamp) return null;
  if (timestamp < TIMESTAMP_CUTOFF) return null;
  if (!calendarDate || daysPassed === null) return null;

  const isToday = daysPassed === 0;
  const isYesterday = daysPassed === 1;
  const isThisWeek = daysPassed < 7;

  let label = null;

  if (isToday || isYesterday) {
    // "Today" / "Yesterday"
    label = (
      <LocalTime
        timestamp={timestamp}
        midnightTick={midnightTick}
        type="weekday"
        className="truncate text-xs/[15px] font-medium text-white capitalize"
      />
    );
  } else if (isThisWeek) {
    // "Wednesday"
    label = (
      <LocalTime
        timestamp={timestamp}
        midnightTick={midnightTick}
        type="time"
        format="%A"
        className="truncate text-xs/[15px] font-medium text-white capitalize"
      />
    );
  } else {
    // "September 21, 2025"
    label = (
      <LocalTime
        timestamp={timestamp}
        midnightTick={midnightTick}
        type="time"
        format="%B %-e, %Y"
        className="truncate text-xs/[15px] font-medium text-white capitalize"
      />
    );
  }

  return (
    // -ml-[22px] cancels the row wrapper's pl-[22px] content inset (an avatar-rail
    // alignment the messages need) so the pill centers on the column's true axis.
    <div className="-ml-[22px] flex justify-center overflow-hidden pt-13 pb-7">
      <div className="inline-flex min-h-7 min-w-[120px] max-w-[calc(100%-32px)] items-center justify-center rounded-full border-[0.5px] border-white/40 bg-idle-blue px-2.5 py-1.5 text-center shadow-[0_4px_16px_rgba(0,0,0,0.1)] backdrop-blur-[20px]">
        {label}
      </div>
    </div>
  );
};

export default DayDivider;
